/**
 * Shared column template for the header, order rows, script rows, and skeleton
 * so every cell lines up. Columns: select · expand · vendor/script · type ·
 * scripts count/index · status · sent · due · actions.
 *
 * Mobile keeps hierarchy + actions; status/due enter at `sm`, type and scripts
 * at `md`, and sent at `lg`.
 */
export const ORDERS_GRID_CLASS =
  "grid items-center gap-x-3 " +
  "grid-cols-[1rem_1rem_minmax(0,1fr)_5.5rem] " +
  "sm:grid-cols-[1rem_1rem_minmax(0,1fr)_11rem_10rem_5.5rem] " +
  "md:grid-cols-[1rem_1rem_minmax(0,1fr)_4.5rem_3.5rem_11rem_10rem_6rem] " +
  "lg:grid-cols-[1rem_1rem_minmax(0,1fr)_4.5rem_3.5rem_11rem_8.5rem_10rem_6rem]";

export const ORDERS_CELL_TYPE_CLASS = "hidden md:block";
export const ORDERS_CELL_SCRIPTS_CLASS = "hidden md:block";
export const ORDERS_CELL_STATUS_CLASS = "hidden sm:block";
export const ORDERS_CELL_SENT_CLASS = "hidden lg:block";
export const ORDERS_CELL_DUE_CLASS = "hidden sm:block";

/** Horizontal padding shared by every row so the grid gutters match. */
export const ORDERS_ROW_PADDING_CLASS = "px-3";

/** Keeps dense checkbox chrome at 16px while expanding its pointer target to 44px. */
export const ORDERS_CHECKBOX_HIT_TARGET_CLASS =
  "relative after:absolute after:-inset-3.5 after:content-['']";
